export const NONE = 'none'
export const SIGNATURE = 'signature'
export const PICKUP_POINT = 'pickup_point'
